import { Component } from '@angular/core';

@Component({
  selector: 'svg-icon-chat-navigation',
  templateUrl: './svg-icon-chat-navigation.svg',
  styleUrls: ['./svg-icon-chat-navigation.component.scss'],
})
export class SvgIconChatNavigationComponent {}
